import { render } from "./PmPage.vue?vue&type=template&id=530c6fe2"
import script from "./PmPage.vue?vue&type=script&lang=js"
export * from "./PmPage.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__